export const zxwkzxRouter = [{
  path: '/zxwkzx',
  component: () => import('./views/index')
}, {
  path: '/zxwkzx/teams',
  component: () => import('./views/teams')
},
  {
    path: '/zxwkzx/intro',
    component: () => import('./views/intro.vue')
  }]



// WEBPACK FOOTER //
// ./src/page/zxwkzx/router.js